import { useNavigate, useParams } from 'react-router';
import { useEffect } from 'react';
import * as R from 'Router/routes';
import useError from 'hooks/useError';

export default function OfflinePSD2Token() {
  const params = useParams();
  const navigate = useNavigate();
  const { showError } = useError();

  useEffect(() => {
    (async function saveToken() {
      /* NOTE: Workaround because of back-end */
      if (!params.token) {
        showError();
        return;
      }
      sessionStorage.setItem('offline-psd2-token', params.token);
      navigate(`${R.OFFLINE_PSD2_BANKS}/${params.token}`);
    })();
  }, []);

  return null;
}
